/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fair_Calm_Dove_DrawInputs */

const en_fair_calm_dove_draw = /** @type {(inputs: Fair_Calm_Dove_DrawInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sending notification...`)
};

const de_fair_calm_dove_draw = /** @type {(inputs: Fair_Calm_Dove_DrawInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benachrichtigung wird gesendet...`)
};

/**
* | output |
* | --- |
* | "Sending notification..." |
*
* @param {Fair_Calm_Dove_DrawInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const fair_calm_dove_draw = /** @type {((inputs?: Fair_Calm_Dove_DrawInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fair_Calm_Dove_DrawInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_fair_calm_dove_draw(inputs)
	return de_fair_calm_dove_draw(inputs)
});